import {DateTime} from "luxon";
import Vue from 'vue';
import { ArrayHelpers } from './ArrayHelpers';

// Сравнивает массивы и обновляет, удаляет и добавляет измененные данные
// Нужна для того, чтобы в компонентах обновлялись только измененнные элементы, без сброса состояния при отображении
// Для корректной работы у элементов должна быть задано поле updatedAt, по которому происходит сравнение
// Если у элементов задано поле orderIndex, то добавление элементов будет происходить с учетом сортировки по этому полю
const vueUpdateArray = <T extends { id: string; updatedAt?: DateTime; orderIndex?: number|null }>(oldData: T[], newData: T[]) => {
    // update changed data
    oldData.forEach((oldDataItem, index) => {
        const updatedItem = newData.find(newDataItem => oldDataItem.id === newDataItem.id 
            && oldDataItem.updatedAt && newDataItem.updatedAt && oldDataItem.updatedAt < newDataItem.updatedAt);
        if (updatedItem) {
            Vue.set(oldData, index, updatedItem);
        }
    })

    // add new items
    const itemsToAdd = ArrayHelpers.differenceBy(newData, oldData, (a, b) => a.id === b.id);
    itemsToAdd.forEach(itemToAdd => {
        if (itemToAdd.orderIndex && itemToAdd.orderIndex !== null) {
            const index = oldData.findIndex(el => el.orderIndex && el.orderIndex > (itemToAdd.orderIndex as number) 
                || el.orderIndex === null);
            if (index !== -1) {
                oldData.splice(index, 0, itemToAdd);
            } else {
                oldData.push(itemToAdd);
            }
        } else {
            oldData.push(itemToAdd);
        }
    });

    // // remove deleted items
    const itemsToRemove = ArrayHelpers.differenceBy(oldData, newData, (a, b) => a.id === b.id);
    itemsToRemove.forEach(itemToRemove => {
        const index = oldData.findIndex(el => el.id === itemToRemove.id);
        if (index >= 0) {
            oldData.splice(index, 1);
        }
    });            
}

export default vueUpdateArray
